import { AsyncPipe, NgClass } from "@angular/common";
import { Component, Input, OnDestroy, ChangeDetectionStrategy, inject } from "@angular/core";
import { ModalServiceAbstract } from "../../services/modal.service.abstract";
import { SessionService } from "../../services/session.service";
import { TokenService } from "../../services/token.service";
import { Subscription } from "rxjs";
import { mergeMap, tap } from "rxjs/operators";
import { ProfilePictureComponent } from "../profile-picture/profile-picture.component";

@Component({
	selector: "rl-upload-profile-picture",
	templateUrl: "./upload-profile-picture.component.html",
	styleUrls: ["./upload-profile-picture.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [NgClass, ProfilePictureComponent, AsyncPipe]
})
export class UploadProfilePictureComponent implements OnDestroy {
	session = inject(SessionService);
	private readonly _modalService = inject(ModalServiceAbstract);
	private readonly _tokenService = inject(TokenService);


	@Input()
	size: "xxs" | "xs" | "sm" | "md" | "lg";

	private subscriptions: Subscription[] = [];

	openUploadModal() {
		const sub = this._modalService.openSelectAvatarModal()
			.pipe(
				tap((result) => this.session.profileAvatar$.next(result)),
				mergeMap(() => this._tokenService.refreshToken()))
			.subscribe();

		this.subscriptions.push(sub);
	}

	ngOnDestroy() {
		this.subscriptions.forEach(sub => sub.unsubscribe());
	}
}
